{
    "translation": {
        "authentication": {
            "wrong_password": "Mot de passe incorrect"
        },
        "authorization": {
            "not_allowed": "Action non autorisée"
        },
        "dossier": {
            "archive": {
                "failed": "Le dossier n'a pas pu être archivé",
                "sucess": "Dossier archivé"
            },
            "close": {
                "failed": "Le dossier n'a pas pu être fermé",
                "sucess": "Dossier terminé"
            },
            "duplicate": {
                "failed": "Le dossier n'a pas pu être dupliqué",
                "sucess": "Dossier dupliqué"
            },
            "status": {
                "eligibility": "analyse éligibilité",
                "pending_enedis_signature": "signature enedis en cours",
                "pending_quotation_signature": "en cours",
                "validated_dossier": "en cours",
                "validated_added_value": "en cours",
                "in_progress": "en cours",
                "archived": "archivé",
                "closed":  "terminé"
            }
        },
        "cspe_record": {            
            "delete": {
                "failed": "La période n'a pas pu être supprimée",
                "success": "Période supprimée"
            },
            "status": {                
                "ok": "Ok",
                "nok": "Ko",
                "checked": "Vérifié"
            }
        },
        "customer": {
            "delete": {                
                "modal_desc_warning": "Attention, cette action entraînera la suppression de toutes les données du client << {{company_name}} >>",
                "modal_title_warning": "Suppression d'un client",
                "success": "Les données ont été supprimées"
            }
        },
        "invoice": {
            "delete": {
                "failed": "La facture n'a pas pu être supprimée",
                "success": "Facture supprimée"
            },
            "index": {
                "missing_structure_data_id": "ID des données de structure manquant"
            }
        },
        "error": {
            "ape_code_not_valid": "Code APE non éligible"
        },
        "structure_data": {
            "get_electric_index": {
                "failed": "Erreur lors de la récupération des consommations auprès de Enedis"
            },
            "eligibility_value": {
                "failed": "Erreur lors du calcul de l'électro-intensivité"
            }
        },
        "tax_return": {
            "status": {
                "validated": "Validé",
                "in_progress": "À compléter"
            }
        },
        "user": {
            "password": {
                "reset_success": "Votre mot de passe a été modifié avec succès !",
                "email_sent": "Un email vient de vous être envoyé pour réinitialiser votre mot de passe",
                "mail_not_found": "Cet email n'existe pas",
                "reset_token_error": "Le lien de renouvellement de mot de passe a expiré - Veuillez refaire la demande",
                "cannot_update_password": "Impossible de mettre à jour votre mot de passe"
            }
        },
        "word": {
            "archives": "Archives",
            "dossiers": "Dossiers",
            "cancel": "Annuler",
            "confirm": "Confirmer",
            "identity": "Identifiant",
            "logout": "Déconnexion",
            "my_account": "Mon compte",
            "parameters": "Paramètres",
            "password": "Mot de passe",
            "remember_me": "Se souvenir de moi",
            "to_connect": "Se connecter",
            "forgot_password_question": "Mot de passe oublié ?",
            "normal_rate_250": "> 250 kVA",
            "normal_rate_36": "<= 36 kVA",
            "normal_rate_36_250": "36 - 250 kVA",
            "closed": "Terminé"
        }
    }
}
